export const Logo = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Cancellazione Crif Italia logo">
    <rect width="40" height="40" rx="10" fill="#003087" />
    <path d="M11 27L20 13L29 27" stroke="#00AEEF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="30.5" r="2.5" fill="#00AEEF" />
  </svg>
);

export const Brand = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <Logo size={compact ? 32 : 38} />
    <div className="leading-none">
      <span className="font-extrabold text-lg tracking-tight text-[#003087]">
        Cancellazione Crif<span className="text-[#00AEEF]"> Italia</span>
      </span>
      {!compact && <span className="block text-[10px] uppercase tracking-[0.22em] text-[#00AEEF] font-semibold mt-1">famiglia Sdebitiamoci</span>}
    </div>
  </div>
);
